import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NbsUserService } from 'src/app/services/nbs-user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  invalidLogin: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private userService: NbsUserService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.userService.logout();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }

    const loginData = {
      username: this.loginForm.controls.username.value,
      password: this.loginForm.controls.password.value
    };

    this.userService.loginControl(loginData.username, loginData.password).subscribe(data => {
      if (data.data == null) {
        this.invalidLogin = true;
        this.loginForm.controls.username.setValue("");
        this.loginForm.controls.password.setValue("");
        this.toastrService.error("Hatalı kullanıcı adı veya şifre. Lütfen tekrar deneyin.");
      }
      else {
        this.userService.saveLoginUser(data.data)
        if (data.data.roleId == 1)
          this.router.navigateByUrl('portal');
        else
          this.router.navigateByUrl('contract');
      }
    })
  }

}
